import styled from "styled-components"

import Button from "@irati/ui/src/Button"
import {Card} from "@irati/ui/src/Layout"
import theme from "@irati/ui/src/global/theme"
import {minWidthMedia} from "@irati/ui/src/global/media"


export const Tracker = styled(Card)`
  margin-top: 60px;
  margin-bottom: 20px;
  background-color: ${theme.colors.greys.lightest};
`

export const CenteredButton = styled(Button)`
  margin: 0 auto;
  display: block;
`

export const EmployeeTotalWrapper = styled.div`
  margin: 10px 0 20px;
  border: 1px solid black;
  border-bottom: none;
`

export const EmployeeTotal = styled.div`
  margin: auto;
  width: 200px;
  position: relative;
  bottom: 10px;
  background: ${theme.colors.greys.lightest};
  text-align: center;
`

export const TooltipWrapper = styled.div`
  display: inline;
  div {
    display: inline;
    position: relative;
    bottom: 2px;
    left: 5px;
  }
`

export const HeadingFlex = styled.div`
  ${minWidthMedia.phone`
    display: flex;
    justify-content: space-between;
  `}
`
